import React from 'react'
import PropTypes from 'prop-types'
import { useLoader } from 'react-three-fiber'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { animated } from 'react-spring/three'
import { MeshPhongMaterial } from 'three'

const modelMaterial = new MeshPhongMaterial({
  color: 0xba8860
})

const getMeshFromAsset = layer => {
  if (layer.type === 'Mesh') {
    return layer
  }
  if (!layer.children || !layer.children[0]) {
    throw new Error('No mesh found in loaded asset')
  }
  return getMeshFromAsset(layer.children[0])
}

export const Model = React.forwardRef(
  ({ url, ...props }, ref) => {
    /** load asset */
    const asset = useLoader(GLTFLoader, url)
    const mesh = getMeshFromAsset(asset.scene)

    const { geometry } = mesh

    return (
      <animated.mesh
        ref={ref}
        geometry={geometry}
        material={modelMaterial}
        {...props}
      />
    )
  }
)

Model.propTypes = {
  type: PropTypes.string,
  url: PropTypes.string
}

export default Model
